import BackendInterface from "./backend-interface";

export default class extends BackendInterface {
	constructor() {
		super();
	}

	async get_pdf_from_html(html_content, file_name) {
		const file_content_type = "text/html";
		const formatted_file_name = file_name.replace(/[^a-zA-Z0-9-_]/g, "");
		const url = "/api/generate-pdf";

		const html_file = this._get_file_from_content(
			html_content,
			file_name,
			file_content_type
		);

		const result = await this.post(url, {
			body_params: {
				filename: formatted_file_name
			},
			files: {
				file: html_file
			},
			expect_file_response: true
		});
		return result;
	}

	_get_file_from_content(content, file_name, file_content_type) {
		const blob = new Blob([content], { type: file_content_type });
		const file = new File([blob], file_name + ".html", {
			type: file_content_type
		});

		return file;
	}
}
